package com.cybersoftsolution.cybersoftsolutionweb.pages.admin

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.LoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.IsAuthenticatedLayout
import com.varabyte.kobweb.core.Page


@Composable
@Page
fun index(){
    //val content = rememberPageContext()

    IsAuthenticatedLayout(delay = 1000L, asAdmin = true) {
        LoadingIndicator()
    }


}